<DataGridView DataUrl="/Backend/Api/V2/Admin/Kassen/List" #Grid KeyProperty="key">
  <DataGridViewColumn field="name" header="Name" />
  <DataGridViewColumn field="mail" header="E-Mail" />
  <DataGridViewColumn field="telefone" header="Telefone" />
  <DataGridViewColumn field="ik" header="IK" />
  <DataGridViewColumn [isFixed]="true"  [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>
      <PopUpView icon="bi bi-pencil-fill" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-primary" header="Kasse">
        <ng-template #staticContent>
          <KasseEdit [Key]="row?.key"></KasseEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
    <ng-template #header>
      <PopUpView icon="bi bi-plus" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-success" header="Kasse">
        <ng-template #staticContent>
          <KasseEdit></KasseEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
  </DataGridViewColumn>
</DataGridView>
